"use client";

import { Info } from "lucide-react";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";

export function PlatformFeeInfo({
  includesGst = false,
}: {
  includesGst?: boolean;
}) {
  return (
    <Popover>
      <PopoverTrigger
        nativeButton
        aria-label="What is the platform fee?"
        className="inline-flex size-5 shrink-0 items-center justify-center rounded-full text-text-tertiary hover:text-text-primary focus-visible:ring-2 focus-visible:ring-brand/40 focus-visible:outline-none"
      >
        <Info aria-hidden="true" className="size-4" />
      </PopoverTrigger>
      <PopoverContent
        align="start"
        className="w-64 border border-border bg-surface p-3 text-sm text-text-primary shadow-lg"
      >
        <p>
          This fee helps us operate and maintain the Hiive platform.
          {includesGst ? " This includes GST." : ""}
        </p>
      </PopoverContent>
    </Popover>
  );
}
